import { cn } from '@/src/infrastructure/lib/utils';
import type { ApiInvitationStatus } from '@/src/types';

const STATUS_LABEL: Record<ApiInvitationStatus, string> = {
  DRAFT: 'Draft',
  PROCESSING: 'Publishing…',
  PUBLISHED: 'Active',
  FAILED: 'Failed',
  EXPIRED: 'Expired',
  ARCHIVED: 'Archived',
  CANCELLED: 'Cancelled',
  SCHEDULED: 'Scheduled',
  SUSPENDED: 'Suspended',
  REPORTED: 'Reported',
};

// Tailwind tone per status. Reuses the existing palette tokens defined in
// invitecloudFrontend/index.css; new lifecycle states fall back to neutral
// chips with role-appropriate accent colours.
const STATUS_CLASS: Record<ApiInvitationStatus, string> = {
  DRAFT: 'bg-status-draft/10 text-status-draft',
  PROCESSING: 'bg-status-processing/10 text-status-processing',
  PUBLISHED: 'bg-status-published/10 text-status-published',
  FAILED: 'bg-status-failed/10 text-status-failed',
  EXPIRED: 'bg-on-surface-variant/10 text-on-surface-variant',
  ARCHIVED: 'bg-amber-500/10 text-amber-600',
  CANCELLED: 'bg-rose-500/10 text-rose-600',
  SCHEDULED: 'bg-sky-500/10 text-sky-600',
  SUSPENDED: 'bg-red-500/10 text-red-600',
  REPORTED: 'bg-orange-500/10 text-orange-600',
};

export function InvitationStatusBadge({ status }: { status: ApiInvitationStatus }) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-3 py-1 rounded-full font-bold text-xs shadow-sm',
        STATUS_CLASS[status] ?? 'bg-on-surface-variant/10 text-on-surface-variant',
      )}
    >
      {STATUS_LABEL[status] ?? status}
    </span>
  );
}
